<script setup lang="ts">
const { isLayoutMobileOrTablet } = useLayout();

// todo: translate all texts

const resetTextByBrowser = computed<string>(() => {
  const userAgent = navigator.userAgent;

  if (userAgent.includes('Chrome') && !userAgent.includes('Edg')) {
    return `chrome`;
  } else if (userAgent.includes('Firefox')) {
    return `firefox`;
  } else if (
    userAgent.includes('Safari') &&
    !userAgent.includes('Chrome') &&
    !isLayoutMobileOrTablet.value
  ) {
    return `safari`;
  } else if (userAgent.includes('iPhone') && !userAgent.includes('Chrome')) {
    return `iPhone`;
  } else if (userAgent.includes('Edg')) {
    return `edge`;
  } else if (userAgent.includes('Opera') || userAgent.includes('OPR')) {
    return `opera`;
  } else {
    return 'Para resetar suas permissões de geolocalização, por favor, vá até as configurações do seu navegador, encontre a seção de permissões de localização e faça as alterações necessárias.';
  }
});
</script>

<template>
  <section :class="$style.tutorialSection">
    <template v-if="resetTextByBrowser === 'chrome'">
      <p :class="$style.title">Para Navegodor Chrome:</p>
      <ul>
        <li>
          Clique no <strong>ícone de geolocalização</strong> na barra de
          endereços para gerenciar as permissões do site.
        </li>
      </ul>
      <br />
      - Ou -
      <br /><br />
      <ul>
        <li>
          Clique no ícone de <strong>três pontos verticais</strong> no canto
          superior direito e selecione <strong>Configurações</strong>.
        </li>
        <li>
          No menu à esquerda, clique em
          <strong>Privacidade e segurança</strong> e depois em
          <strong>Configurações de site</strong>.
        </li>
        <li>Role para baixo e clique em <strong>Localização</strong>.</li>
        <li>
          Encontre nosso site na lista e ajuste a permissão de localização para
          <strong>Permitir</strong>.
        </li>
      </ul>
    </template>

    <template v-else-if="resetTextByBrowser === 'firefox'">
      <p :class="$style.title">Para Navegodor Firefox:</p>
      <ul>
        <li>
          Clique no ícone de <strong>três linhas horizontais</strong> no canto
          superior direito e selecione <strong>Configurações</strong>.
        </li>
        <li>
          No menu à esquerda, clique em
          <strong>Privacidade e segurança</strong>.
        </li>
        <li>
          Role até a seção <strong>Permissões</strong> e clique em
          <strong>Configurações...</strong> ao lado de
          <strong>Localização</strong>.
        </li>
        <li>
          Encontre o site na lista e ajuste as permissões para
          <strong>Permitir</strong>.
        </li>
        <li>Clique em <strong>Salvar alterações</strong>.</li>
      </ul>
    </template>

    <template v-else-if="resetTextByBrowser === 'safari'">
      <p :class="$style.title">Para Navegodor Safari:</p>
      <ul>
        <li>
          No canto superior esquerdo, clique em <strong>Safari</strong> no menu
          e selecione <strong>Preferências</strong>.
        </li>
        <li>
          Vá para a aba <strong>Sites</strong> e, no menu à esquerda, selecione
          <strong>Localização</strong>.
        </li>
        <li>
          Encontre o site na lista e ajuste as permissões para
          <strong>Permitir</strong>.
        </li>
      </ul>
    </template>

    <template v-else-if="resetTextByBrowser === 'edge'">
      <p :class="$style.title">Para Navegodor Edge:</p>
      <ul>
        <li>
          Clique no ícone de <strong>três pontos horizontais</strong> no canto
          superior direito e selecione <strong>Configurações</strong>.
        </li>
        <li>
          No menu à esquerda, clique em
          <strong>Cookies e permissões de site</strong> e depois em
          <strong>Localização</strong>.
        </li>
        <li>
          Encontre o site na lista e ajuste as permissões para
          <strong>Permitir</strong> ou <strong>Bloquear</strong>.
        </li>
        <li>Atualize a página para aplicar as novas permissões.</li>
      </ul>
    </template>

    <template v-else-if="resetTextByBrowser === 'opera'">
      <p :class="$style.title">Para Navegodor Opera:</p>
      <ul>
        <li>
          Clique no ícone de <strong>Configurações</strong> no canto superior
          direito ou vá ao menu <strong>Opera</strong> e selecione
          <strong>Configurações</strong>.
        </li>
        <li>
          No menu lateral esquerdo, selecione <strong>Avançado</strong> e depois
          clique em <strong>Privacidade e segurança</strong>.
        </li>
        <li>
          Em <strong>Configurações de site</strong>, role para baixo e clique em
          <strong>Localização</strong>.
        </li>
        <li>
          Encontre o site na lista e ajuste a permissão para
          <strong>Permitir</strong> ou <strong>Bloquear</strong>.
        </li>
      </ul>
    </template>

    <template v-else-if="resetTextByBrowser === 'iPhone'">
      <p :class="$style.title">Para iPhone:</p>
      <ol>
        <li>Abra o aplicativo <strong>Ajustes</strong> no seu iPhone.</li>
        <li
          >Role para baixo e toque em <strong>Privacidade e Segurança</strong>.
        </li>
        <li>Toque em <strong>Serviços de Localização</strong>.</li>
        <li
          >Certifique-se de que a opção
          <strong>Serviços de Localização</strong> esteja ativada.
        </li>
        <li
          >Role para baixo e encontre o aplicativo específico para o qual você
          deseja permitir o acesso à localização.
        </li>
        <li
          >Toque no aplicativo (chrome ou safari) e escolha uma das seguintes
          opções:
          <ul>
            <li
              ><strong>Perguntar na Próxima Vez ou Quando Compartilhar</strong>:
              O aplicativo solicitará permissão sempre que for necessário.
            </li>
            <li
              ><strong>Durante o Uso do App</strong>: O aplicativo pode acessar
              sua localização apenas enquanto estiver em uso.
            </li>
            <li
              ><strong>Sempre</strong>: O aplicativo pode acessar sualocalização
              mesmo em segundo plano.
            </li>
            <li
              ><strong>*</strong>: Se já estiver em alguma dessas opções apenas
              siga para o próximo passo.
            </li>
          </ul>
        </li>
        <li
          >Regarregue esta página:
          <ul>
            <li>
              Clique no ícone de <strong>três pontos horizontais</strong> no
              canto inferior direito e selecione <strong>Regarregar</strong>.
            </li>
          </ul>
        </li>
      </ol>
    </template>

    <template v-else>
      <div class="alert alert-warning">
        {{ resetTextByBrowser }}
      </div>
    </template>

    <div class="alert alert-error mt-5">
      {{ $t('verification.gps.tutorial.alert') }}
    </div>
  </section>
</template>

<style module lang="scss">
.tutorialSection {
  @apply text-left;

  .title {
    @apply font-semibold mb-2;
  }

  ol {
    li {
      @apply list-decimal list-inside;
    }
  }

  ul {
    li {
      @apply list-disc list-inside ml-2;
    }
  }
}
</style>
